import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {
  PersonOutline as Member,
  CollectionsBookmark as Practices,
  CreditCard as Payments,
  Assignment as Documents,
  School,
  Loyalty as Voucher,
  Settings as Upselling,
} from '@material-ui/icons';

// Rebranding 2026 · CardLink → gc-sc-cardlink con tier (blue/silver/gold/diamond)
// API: text, to, tier, eyebrow?, description?, icon?, onClick?
// Se `icon` è omesso → card "compatta" (4 sezioni Dashboard cliente)
// Se `icon` è presente + `tall` → card "alta" (Dashboard docente choice)

const Icons = {
  Member, Practices, Payments, Documents, School, Voucher, Upselling,
};

const TIER_FROM_BACKGROUND = {
  '#69b9ff': 'blue',
  '#3F50BA': 'blue',
  '#FB8B01': 'gold',
  '#50C254': 'diamond',
  '#E91E63': 'silver',
};

const CARDLINK_GWM_STYLE = {
  tall: {width: 220, height: 220, right: -40, bottom: -50},
  default: {width: 170, height: 170, right: -30, bottom: -34},
};

const resolveCardLinkTier = (tier, background) =>
  tier || TIER_FROM_BACKGROUND[background] || 'blue';

const CardLink = ({icon, text, background, to, onClick, tier, description, eyebrow, tall}) => {
  const t = resolveCardLinkTier(tier, background);
  const Icon = icon ? (Icons[icon] || Member) : null;
  const gwmVariant = t === 'blue' ? 'light' : 'dark';
  const classes = [
    'gc-sc-cardlink',
    `gc-sc-cardlink--tier-${t}`,
    tall ? 'gc-sc-cardlink--tall' : '',
  ].filter(Boolean).join(' ');

  const gwmStyle = tall ? CARDLINK_GWM_STYLE.tall : CARDLINK_GWM_STYLE.default;

  return (
    <Link to={to} onClick={onClick} className={classes}>
      <span
        className={`gc-gwm gc-gwm--${gwmVariant}`}
        style={gwmStyle}
        aria-hidden="true"
      />

      {Icon && (
        <span className="gc-sc-cardlink__iconbox">
          <Icon style={{fontSize: 28}} />
        </span>
      )}

      {eyebrow && <p className="gc-sc-cardlink__eyebrow">{eyebrow}</p>}
      <span className="gc-sc-cardlink__text">{text}</span>
      {description && <p className="gc-sc-cardlink__desc">{description}</p>}

      <span className="gc-sc-cardlink__arrow" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </span>
    </Link>
  );
};

CardLink.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string.isRequired,
  background: PropTypes.string,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  tier: PropTypes.oneOf(['blue', 'silver', 'gold', 'diamond']),
  description: PropTypes.string,
  eyebrow: PropTypes.string,
  tall: PropTypes.bool,
};

export default CardLink;
